import { Chart } from 'react-chartjs-2';

/**
 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
 * given size (width, height)

 * @param {CanvasRenderingContext2D} ctx  The canvas 2D Context.
 *
 * @param {number} x                         The x axis of the coordinate for the rectangle starting point.
 *
 * @param {number} y                         The y axis of the coordinate for the rectangle starting point.
 *
 * @param {number} width                     The rectangle's width.
 *
 * @param {number} height                    The rectangle's height.
 *
 * @param {number} radius                    The rounded amount (in pixels) for the corners
 */
Chart.helpers.roundedRect = function (ctx, x, y, width, height, radius) {
  ctx.beginPath();
  ctx.moveTo(x + Math.abs(radius), y);
  // top right corner
  ctx.lineTo(x + width - Math.abs(radius), y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
  // bottom right corner
  ctx.lineTo(x + width, y + height);
  // bottom left corner
  ctx.lineTo(x, y + height);
  // top left
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + Math.abs(radius), y);
  ctx.closePath();
};

/**
 * Draw the Rounded Rectangle
 * - if dataset.ignoreCurving is true -> don't curve the corner
 * - Otherwise, basing on of current bar 's y, if above x-axis ->  rounded top corner - otherwise bottom corner
 */
Chart.elements.RoundedRectangle = Chart.elements.Rectangle.extend({
  draw: function () {
    const ctx = this._chart.ctx;
    const currentView = this._view;
    const chartConfig = this._chart.config;

    const borderWidth = currentView.borderWidth;
    const currentDataset = chartConfig.data.datasets[this._datasetIndex];

    // bar
    const left = currentView.x - currentView.width / 2;
    const right = currentView.x + currentView.width / 2;
    let top = currentView.y;
    const bottom = currentView.base;

    // calculate the bar width and roundness
    const barWidth = Math.abs(left - right);
    const barHeight = Math.abs(top - bottom);
    const roundness = chartConfig.options.barRoundness || 0.2;
    const radius = barWidth * roundness * 0.5;

    // keep track of the original top of the bar
    const prevTop = top;

    // move the top down so there is room to draw the rounded top
    top = prevTop + radius;
    const barRadius = top - prevTop;

    ctx.beginPath();
    ctx.fillStyle = currentView.backgroundColor;
    ctx.strokeStyle = currentView.borderColor;
    ctx.lineWidth = borderWidth;

    // if no data, we dont need to render rect
    if (!currentDataset.data[this._index]) return;

    if (currentDataset && currentDataset.ignoreCurving) {
      // render normal rect
      ctx.rect(left, top - barRadius + 1, barWidth, bottom - prevTop);
    } else {
      if (currentDataset.fullyCurving) {
        // render fully rounded bar
        const barRadiusHeight = barHeight - 5;
        Chart.helpers.drawRoundedRectangle(
          ctx,
          left,
          prevTop + 5,
          barWidth,
          barRadiusHeight < 0 ? 0 : barRadiusHeight,
          5
        );
      } else {
        // draw the rounded top rectangle
        Chart.helpers.roundedRect(
          ctx,
          left,
          top - barRadius + 1,
          barWidth,
          bottom - prevTop,
          // if bar above x-axis -> rounded top only,  otherwise  rounded bottom
          currentView.y < currentView.base ? barRadius : -barRadius
        );
      }
    }

    ctx.fill();
    ctx.stroke();
  },
});
